/**
 * Created by Oles on 5/2/2017.
 */
export const MessageBoxTypes ={
    DELETE_TEST: 'DELETE_TEST',
    DELETE_DOC: 'DELETE_DOC',
    AMBRY_KEYS: 'AMBRY_KEYS',
    MULTIPLE_REPORTS: 'MULTIPLE_REPORTS',
    BLACKLIST_FILES_UPLOADED: 'BLACKLIST_FILES_UPLOADED',
    ERROR: 'ERROR'
};

export const MessageBoxHeaders = {
    DELETE_TEST: 'Delete Test',
    DELETE_DOC: 'Delete Document',
    AMBRY_KEYS: 'Ambry Orders - Setup',
    MULTIPLE_REPORTS: 'Multiple Reports',
    BLACKLIST_FILES_UPLOADED: 'Information Message',
    ERROR: 'ERROR'
};

export const MessageBoxTexts = {
    DELETE_TEST: 'deleteTestConfirm',
    DELETE_DOC: 'deleteDocConfirm',
    AMBRY_KEYS: "ambryKeysMessage",
    MULTIPLE_REPORTS: 'multipleReportsMessage',
    BLACKLIST_FILES_UPLOADED: 'blacklistFilesErrorMessage',
    ERROR: ''
};

export const MessageBoxConfirmBtnTexts = {
    DELETE_TEST: 'Delete',
    DELETE_DOC: 'Delete',
    AMBRY_KEYS: 'Close',
    MULTIPLE_REPORTS: 'Close',
    BLACKLIST_FILES_UPLOADED: '',
    ERROR: 'OK'
};

export const MessageBoxCancelBtnTexts = {
    DELETE_TEST: 'Cancel',
    DELETE_DOC: 'Cancel',
    AMBRY_KEYS: 'Cancel',
    BLACKLIST_FILES_UPLOADED: 'Close'
};

//temp genes classifications list
export const GenesClassifications = [
    "Pathogenic",
    "Likely Pathogenic",
    "VUS",
    "Likely Benign",
    "Negative"
];

export const TestStatuses = {
    PENDING: "In Progress",
    REPORTED: "Reported",
    COMPLETED: "Cancelled"
};

export const OTHER_LAB_OPTION_NAME = 'Other';
export const OTHER_TEST_OPTION_NAME = 'Other';